<!--
 * @Date: 2020-08-11 19:24:21
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2021-01-30 11:41:57
 * @FilePath: \pc-mall\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
    <!-- 维护 -->
    <el-dialog
      class="maintenanceDialogVisible"
      :visible.sync="maintenance"
      width="400px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <span style="color: darkred;font-size: 18px;">{{maintenanceText}}</span>
    </el-dialog>
  </div>
</template>

<script>
import { getSystemUpdate } from '@/api/buyTicket'
export default {
  name: 'app',
  data () {
    return {
      maintenanceText: null,
      maintenance: false,
      timeOut: 15 * 60 * 1000
    }
  },
  created () {
    this.getSystemUpdate()
  },
  mounted () {
    // 每15秒 调用检查时间的方法
    this.$nextTick(function () {
      setInterval(this.checkTimeout, 20000)
    }) // 页面监听 按下鼠标更新操作时间
    window.onload = function () {
      window.document.onmousedown = function () {
        localStorage.setItem('lastTime', new Date().getTime())
      }
    }
  },
  methods: {
    checkTimeout () {
      // 更新当前时间
      const currentTime = new Date().getTime()
      const lastTime = localStorage.getItem('lastTime')
      // 判断是否超时
      if (currentTime - lastTime > this.timeOut) {
        // 调用自己的注销接口
        if (sessionStorage.getItem('loginState') == null) {
          return
        }
        const that = this
        this.$alert('登录超时', '提醒', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action)
            sessionStorage.removeItem('token')
            sessionStorage.removeItem('loginState')
            that.LoginBtnShow = false
            location.reload()
          }
        })
        localStorage.removeItem('lastTime')
      }
    },
    getSystemUpdate () {
      this.maintenanceText = null
      getSystemUpdate().then(res => {
        if (res.code === 0) {
          if (res.data && res.data) {
            this.maintenanceText = res.data
            this.maintenance = true
          } else {
            this.maintenance = false
          }
        }
      })
      setTimeout(this.getSystemUpdate, 60 * 1000 * 2)
    }
  }
}
</script>

<style lang="scss">
@import "./common/lightgray/content.min.css";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  .picker-options {
    .el-input--prefix .el-input__inner {
      padding-right: 0 !important;
      padding-left: 36px !important;
    }
  }
  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }
  .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
}
.maintenanceDialogVisible {
  .el-dialog {
    border-radius: 12px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 30px 20px;
    text-align: center;
    line-height: 32px;
  }
}
</style>
